import { derived, writable } from 'svelte/store';
import { RESULTS_PER_PAGE } from '../../../modules/searchanise.js';

export const collectionProducts = writable([]);
export const searchResponse = writable([]);
export const productCount = derived(
  searchResponse,
  $searchResponse => $searchResponse.totalItems || 0
);
export const currentPage = writable(1);
export const totalPages = derived(
  searchResponse,
  $searchResponse =>
    Math.ceil($searchResponse.totalItems / RESULTS_PER_PAGE) || 1
);
